export default __webpack_public_path__ + "static/media/AssetTable.219d3bc5.webp";